import React from "react";
import { ITEMS_MODE_NAME, toCssUrlValue } from "../../functions/themeAssets";

/** Renders a belt / drop / flyer item as image or text-on-background. */
export function BeltItemContent({ item, imgClassName = "item_img img-fluid" }) {
  if (!item?.url) return null;
  if (item.itemKind === ITEMS_MODE_NAME && item.label) {
    return (
      <div
        className="item-name-tile"
        style={{
          backgroundImage: toCssUrlValue(item.url),
        }}
      >
        <span className="item-name-label">{item.label}</span>
      </div>
    );
  }
  return <img src={item.url} alt="" className={imgClassName} draggable={false} />;
}
